// Admin Classes
export default function AdminClasses() { return <div><h1 className="text-3xl font-bold">Classes Management</h1><p className="mt-4">Manage class types, schedules, and venues.</p></div>; }